import {recipeCategoriesSyncCache} from "./mealplannerApi.ts";
import $ from "../$.js";
import * as Html from "../util/Html.ts";
import TPL from "./recipeCategoriesEditContent.mustache";

Html.registerWidget('mealplanner/recipeCategoriesEditWidget',{init:init,destroy:destroy})

var node;

function init(obj){
  node = obj;
  recipeCategoriesSyncCache.subscribe(updateUI)
}
function destroy(obj){
  node = undefined;
  recipeCategoriesSyncCache.unsubscribe(updateUI)
}

function updateUI(freshCat){
  if(node){
    var selected = [];
    node.find('input').each((idx,input)=>{
      if(!$(input).prop('disabled')){
        selected.push(input.value)  
      }
    })
    var catWithData = freshCat.map(cat=>{
      return {
        assigned:selected.indexOf(cat.metaId)>-1,
        category:cat
      }
    })
    Html.setHtml(node,TPL,{categories:catWithData})  
  }
  
}